(function () {
  'use strict';
  var KEY = 'skPrePurchaseLead:v1';
  var TTL = 30 * 60 * 1000;

  function init(doc, win) {
    if (doc.__skContactAnalytics || win.location.pathname !== '/pages/contact') return;
    var panel = doc.querySelector('[data-sk-contact-panel="pre"]');
    if (!panel) return;
    var form = panel.closest('form');
    if (!form || !form.id) return;
    doc.__skContactAnalytics = true;
    var started = false;
    var complete = false;
    var payload = { lead_type: 'pre_purchase', form_location: 'contact' };
    function validMode(mode) { return ['quick', 'detailed'].indexOf(mode) !== -1 ? mode : null; }
    function sourcePayload(mode) {
      return validMode(mode) ? { lead_source: 'concierge', diagnosis_mode: mode } : {};
    }
    function sourceMode() {
      if (validMode(panel.dataset.skConciergeMode)) return panel.dataset.skConciergeMode;
      // Preserve provenance only across this native form's validation-error retry.
      if (panel.dataset.skContactResponse !== 'error') return null;
      try {
        var pending = JSON.parse(win.sessionStorage.getItem(KEY));
        if (decodeURIComponent(win.location.hash.slice(1)) === form.id && pending && pending.form === form.id && typeof pending.at === 'number' && Date.now() - pending.at >= 0 && Date.now() - pending.at < TTL) return validMode(pending.diagnosis_mode);
      } catch (_) { /* No attribution when its provenance cannot be verified. */ }
      return null;
    }

    function allowed() {
      try {
        var query = new URLSearchParams(win.location.search);
        var qa = query.get('concierge_qa') === '1' || query.has('preview_theme_id');
        try {
          if (qa) win.sessionStorage.setItem('skConciergeQA:v1', '1');
          else if (query.get('concierge_qa') === '0') win.sessionStorage.removeItem('skConciergeQA:v1');
          qa = qa || win.sessionStorage.getItem('skConciergeQA:v1') === '1';
        } catch (_) { /* Explicit QA URLs still work when storage is blocked. */ }
        if (qa) { consume(); return false; }
        return !win.Shopify.designMode && win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
      }
      catch (_) { return false; }
    }
    function ready() { return typeof win.gtag === 'function' || Array.isArray(win.dataLayer); }
    function emit(name, mode) {
      if (!allowed() || !ready()) return false;
      try {
        var eventPayload = Object.assign({}, payload, sourcePayload(mode));
        if (typeof win.gtag === 'function') win.gtag('event', name, eventPayload);
        else (function () { win.dataLayer.push(arguments); })('event', name, eventPayload);
        return true;
      } catch (_) { return false; }
    }
    function consume() {
      try {
        win.sessionStorage.removeItem(KEY);
        return win.sessionStorage.getItem(KEY) === null;
      } catch (_) { return false; }
    }
    function completion() {
      if (complete || panel.dataset.skContactResponse !== 'success' || !allowed() || !ready()) return;
      var hash;
      var pending;
      try {
        hash = decodeURIComponent(win.location.hash.slice(1));
        pending = JSON.parse(win.sessionStorage.getItem(KEY));
      } catch (_) { return; }
      // Both contact forms can expose Shopify's success response. Only the
      // submitted pre-purchase form and its short-lived attempt qualify.
      if (hash !== form.id || !pending || pending.form !== form.id || typeof pending.at !== 'number') return;
      var age = Date.now() - pending.at;
      if (age < 0 || age >= TTL) { consume(); return; }
      // Consume before dispatch: an analytics error must not duplicate a lead
      // on reload. When storage is unavailable, prefer an uncounted lead.
      if (!consume()) return;
      complete = true;
      emit('generate_lead', pending.diagnosis_mode);
      if (validMode(pending.diagnosis_mode)) emit('concierge_lead_completed', pending.diagnosis_mode);
    }
    panel.addEventListener('input', function (event) {
      if (!event.isTrusted || panel.disabled || panel.hidden || started || panel.dataset.skContactResponse === 'success') return;
      started = emit('consultation_form_start', sourceMode());
    });
    form.addEventListener('submit', function () {
      if (panel.disabled || panel.hidden) return;
      if (!allowed()) { consume(); return; }
      // No form values, identity, query string, or referrer is retained.
      try {
        var attempt = { form: form.id, at: Date.now() }, mode = sourceMode();
        if (mode) attempt.diagnosis_mode = mode;
        win.sessionStorage.setItem(KEY, JSON.stringify(attempt));
      }
      catch (_) { /* A normal enquiry never depends on analytics storage. */ }
    });
    // A later support submission must not complete an earlier sales attempt.
    doc.querySelectorAll('[data-sk-contact-panel="post"]').forEach(function (post) {
      post.closest('form').addEventListener('submit', consume);
    });
    doc.addEventListener('visitorConsentCollected', completion);
    win.addEventListener('load', completion);
    completion();
    if (win.Shopify && typeof win.Shopify.loadFeatures === 'function' && !win.Shopify.customerPrivacy) {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) completion(); });
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { init: init };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document, window); });
    else init(document, window);
  }
})();
